import { render } from "./PCLogisticExistenceUL.vue?vue&type=template&id=c4f25070"
import script from "./PCLogisticExistenceUL.vue?vue&type=script&lang=js"
export * from "./PCLogisticExistenceUL.vue?vue&type=script&lang=js"

import "./PCLogisticExistenceUL.vue?vue&type=style&index=0&id=c4f25070&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__